import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Homepage from "./container/HomePage/HomePage";
import Footer from "./component/Footer/Footer";
import Header from "./component/Header/Header";
import About from "./container/About/About";

import OurBrands from "./container/OurBrands/OurBrands";
import Collaborate from "./container/Collaborate/Collaborate";

import Contactus from "./container/ContactUS/Contactus";
import Careers from "./container/Careers/Careers";
import PageNotFound from "./container/PageNotFound/PageNotFound";
import InternalServerError from "./container/InternalServerError/InternalServerError";
import Media from "./container/Media/Media";
import PrivacyPolicy from "./container/PrivacyPolicy/PrivacyPolicy";
import Maintainence from "./container/Maintainence/Maintainence";

const DefaultLayout = (props) => {
  return (
    <>
      <Header />
      <div className="marginMiddleHomeContainer">
        <Switch>
          {/* <Route exact path="/" component={InternalServerError} /> */}
          <Route exact path="/" component={Homepage} />
          <Route exact path="/about" component={About} />
          {/* <Route exact path="/about" component={Maintainence} /> */}
          <Route exact path="/contactus" component={Contactus} />

          <Route exact path="/our-brands" component={OurBrands} />

          <Route exact path="/collaborate" component={Collaborate} />
          {/* <Route exact path="/collaborate" component={Maintainence} /> */}

          <Route exact path="/careers" component={Careers} />
          <Route exact path="/404" component={PageNotFound} />
          <Route exact path="/500" component={InternalServerError} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/media" component={Media} />
          <Route exact path="/media/:id" component={Media} />
          <Redirect to="/404"></Redirect>
        </Switch>
      </div>
      <Footer history={props.history} />
    </>
  );
};

export default DefaultLayout;
